import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  tableWrapper: {
    height: "64vh",
    width: "100%",
  },
  table: {
    minWidth: 1000,
    minHeight: 400,
    borderRadius: ({ showBorder }) => showBorder ? "10px" : 0,
    borderColor: ({ theme }) => theme.palette.bgColor,
    backgroundColor: ({ theme }) => theme.palette.bgColor,
  },
});
